<div class="survey-container">
  <div class="text-container">
    <div class="title">{{ 'WebApp.v1.Survey.SurveyBody.Title' | translate }}</div>
    <div class="description">{{ 'WebApp.v1.Survey.SurveyBody.Description' | translate }}</div>
    <div class="description">{{ 'WebApp.v1.Survey.SurveyBody.IndicatePain' | translate }}</div>
    <div class="buttons">
      <ng-container *ngTemplateOutlet="narrowScreenButtons ? mobileButtons : buttons"></ng-container>
    </div>
  </div>
  <div class="body-figure-section">
    <app-body-figure
      #bodyFigure
      (bodyPartSelected)="onBodyPartSelected($event)"
      (bodyPainChanged)="onBodyPainChanged($event)"
    ></app-body-figure>
  </div>
  <div class="body-actions">
    <app-button
      [class.hide]="!(selectedBodyPart || hasPain)"
      class="button"
      [fontSize]="14"
      [label]="'WebApp.v1.Shared.Buttons.NextBodyPart' | translate"
      backgroundColor="transparent"
      (click)="onNextBodyPartClick()"
    ></app-button>
    <app-button
      class="button"
      [class.hide]="!hasPain && !hasNoPainClicked"
      [fontSize]="14"
      [label]="'WebApp.v1.Shared.Buttons.Finish' | translate"
      backgroundColor="transparent"
      iconLeft="fa-solid fa-person"
      iconRight="fa-solid fa-play"
      backgroundColor="#56FA98"
      [disabled]="!surveySession"
      [waitCursor]="!surveySession"
      (click)="onCompleteClick()"
    ></app-button>
  </div>
</div>

<ng-template #buttons>
  <app-button
    class="button reset"
    [fontSize]="12"
    [label]="'WebApp.v1.Shared.Buttons.ResetAll' | translate"
    backgroundColor="transparent"
    [border]="'1px solid #C53333'"
    [class.visible]="hasPain"
    (click)="onResetAllClick()"
  ></app-button>
  @if (bodyPrefill) {
    <app-button
      class="button"
      [class.hide]="selectedBodyPart"
      [fontSize]="12"
      iconLeft="fa-regular fa-rotate-left"
      [label]="'WebApp.v1.Shared.Buttons.RefillFromLastTime' | translate"
      backgroundColor="transparent"
      iconColor="#2CDAFF"
      (click)="onRefillClick()"
    ></app-button>
  }

  @if (!isOnDemand) {
    <app-button
      class="button"
      [fontSize]="12"
      [label]="'WebApp.v1.Shared.Buttons.IDontHaveAnyPain' | translate"
      backgroundColor="transparent"
      iconLeft="fa-regular fa-face-smile"
      iconColor="#56FA98"
      [disabled]="!surveySession"
      [waitCursor]="!surveySession"
      (click)="onNoPainClick()"
    ></app-button>
  }
</ng-template>

<ng-template #mobileButtons>
  @if (selectedBodyPart) {
    <app-button
      class="button"
      [fontSize]="12"
      [label]="'WebApp.v1.Shared.Buttons.Save' | translate"
      backgroundColor="transparent"
      (click)="onSaveBodyPartPainClick()"
    ></app-button>
  } @else {
    @if (hasPain) {
      <app-button
        class="button"
        [fontSize]="12"
        [label]="'WebApp.v1.Shared.Buttons.Finish' | translate"
        backgroundColor="#56FA98"
        iconLeft="fa-solid fa-person"
        iconRight="fa-solid fa-play"
        [disabled]="!surveySession"
        [waitCursor]="!surveySession"
        (click)="onCompleteClick()"
      ></app-button>
    } @else {
      <app-button
        class="button"
        [fontSize]="12"
        iconLeft="fa-regular fa-rotate-left"
        [label]="'WebApp.v1.Shared.Buttons.RefillFromLastTime' | translate"
        backgroundColor="transparent"
        iconColor="#2CDAFF"
        [class.hide]="selectedBodyPart"
        (click)="onRefillClick()"
      ></app-button>

      @if (!isOnDemand) {
        <app-button
          class="button"
          [fontSize]="12"
          [label]="'WebApp.v1.Shared.Buttons.IDontHaveAnyPain' | translate"
          backgroundColor="transparent"
          iconLeft="fa-regular fa-face-smile"
          iconColor="#56FA98"
          [disabled]="!surveySession"
          [waitCursor]="!surveySession"
          (click)="onNoPainClick()"
        ></app-button>
      }
    }
  }
</ng-template>
